import { useQuery } from "react-query";
import { courseCTKApiRequest } from "./client";
import { normalizeCTKDuplicate } from "../util";
function fetchContentToolkitToken({
  pathId,
  pathVersion,
  membership,
  mode,
  takeId,
  takeSessionId,
  authSubject
}) {
  const authSubjectQuery = authSubject ? `&authSubject=${authSubject}` : "";
  return courseCTKApiRequest({
    url: `/content-toolkit/token?pathId=${normalizeCTKDuplicate(
      pathId
    )}&pathVersion=${pathVersion}&membership=${membership}&mode=${mode}&takeId=${takeId}&takeSessionId=${takeSessionId}${authSubjectQuery}`
  });
}
function useContentToolkitTokenQuery({
  pathId,
  pathVersion,
  mode,
  membership,
  takeId,
  takeSessionId,
  authSubject
}) {
  return useQuery(
    [
      "contentToolkitToken",
      pathId,
      pathVersion,
      mode,
      membership,
      takeId,
      authSubject
    ],
    () => fetchContentToolkitToken({
      pathId,
      pathVersion,
      mode,
      membership,
      takeId,
      takeSessionId,
      authSubject
    }),
    { enabled: !!pathId && !!pathVersion && !!takeId, cacheTime: 0 }
  );
}
export {
  fetchContentToolkitToken,
  useContentToolkitTokenQuery
};
